const timestamp = (value) => {
  const time = new Date(value);

  return `${`0${time.getHours()}`.slice(-2)}:${`0${time.getMinutes()}`.slice(
    -2
  )}:${`0${time.getSeconds()}`.slice(-2)}`;
};

export default timestamp;
